import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { FolderEditInterface } from "../../../middleware/interfaces/folder/folder-edit-interface";

export const FolderEdit = {
  Edit: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const folderEditData: FolderEditInterface = state.data;
      const url = "./php/folder/folder-editor-proxy.php";
      await axios
        .post(url, folderEditData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
